import type { PathMethodType } from "../../hooks/useYearContext";
import {
  apprentice_education_report_self_assessment_path,
  certificate_reports_path,
  duplicate_certificate_configurations_path,
  duplicate_education1_configurations_path,
  duplicate_education2_configurations_path,
  duplicate_jumpstart_certificate_configurations_path,
  duplicate_probation_configurations_path,
  edit_certificate_configuration_path,
  edit_certificate_report_path,
  edit_education_report_path,
  edit_education1_configuration_path,
  edit_education2_configuration_path,
  edit_jumpstart_certificate_configuration_path,
  edit_jumpstart_certificate_report_path,
  edit_probation_configuration_path,
  edit_probation_report_path,
  education_reports_path,
  generate_certificate_reports_path,
  generate_education_reports_path,
  generate_jumpstart_certificate_reports_path,
  generate_probation_reports_path,
  jumpstart_certificate_reports_path,
  new_certificate_configuration_path,
  new_education1_configuration_path,
  new_education2_configuration_path,
  new_jumpstart_certificate_configuration_path,
  new_probation_configuration_path,
  probation_reports_path,
} from "../../routes";

export enum ReportType {
  EDUC1 = "educ1",
  EDUC2 = "educ2",
  PROP = "prob",
  JUMP = "jump",
  CERT = "cert",
}

export const reportTypeTranslations: Record<ReportType, string> = {
  [ReportType.CERT]: "Zertifikat",
  [ReportType.JUMP]: "Zertifikat JUMPStart",
  [ReportType.PROP]: "Probezeitbericht",
  [ReportType.EDUC1]: "Bildungsbericht Semester 1",
  [ReportType.EDUC2]: "Bildungsbericht Semester 2",
};

export function getReportTypeOptions() {
  return Object.values(ReportType).map((value) => ({ value, label: reportTypeTranslations[value] }));
}

export const newReportTypeConfigRoute: Record<ReportType, PathMethodType> = {
  [ReportType.CERT]: new_certificate_configuration_path,
  [ReportType.JUMP]: new_jumpstart_certificate_configuration_path,
  [ReportType.PROP]: new_probation_configuration_path,
  [ReportType.EDUC1]: new_education1_configuration_path,
  [ReportType.EDUC2]: new_education2_configuration_path,
};

export const editReportTypeConfigRoute: Record<ReportType, PathMethodType> = {
  [ReportType.CERT]: edit_certificate_configuration_path,
  [ReportType.JUMP]: edit_jumpstart_certificate_configuration_path,
  [ReportType.PROP]: edit_probation_configuration_path,
  [ReportType.EDUC1]: edit_education1_configuration_path,
  [ReportType.EDUC2]: edit_education2_configuration_path,
};

export const duplicateReportTypeConfigRoute: Record<ReportType, PathMethodType> = {
  [ReportType.CERT]: duplicate_certificate_configurations_path,
  [ReportType.JUMP]: duplicate_jumpstart_certificate_configurations_path,
  [ReportType.PROP]: duplicate_probation_configurations_path,
  [ReportType.EDUC1]: duplicate_education1_configurations_path,
  [ReportType.EDUC2]: duplicate_education2_configurations_path,
};

export const editReportTypeRoute: Record<ReportType, PathMethodType> = {
  [ReportType.CERT]: edit_certificate_report_path,
  [ReportType.JUMP]: edit_jumpstart_certificate_report_path,
  [ReportType.PROP]: edit_probation_report_path,
  [ReportType.EDUC1]: edit_education_report_path,
  [ReportType.EDUC2]: edit_education_report_path,
};

export const createReportTypeRoute: Record<string, PathMethodType> = {
  [ReportType.CERT]: certificate_reports_path,
  [ReportType.JUMP]: jumpstart_certificate_reports_path,
  [ReportType.PROP]: probation_reports_path,
  [ReportType.EDUC1]: education_reports_path,
  [ReportType.EDUC2]: education_reports_path,
};

export const generateReportTypeRoute: Record<string, PathMethodType> = {
  [ReportType.CERT]: generate_certificate_reports_path,
  [ReportType.JUMP]: generate_jumpstart_certificate_reports_path,
  [ReportType.PROP]: generate_probation_reports_path,
  [ReportType.EDUC1]: generate_education_reports_path,
  [ReportType.EDUC2]: generate_education_reports_path,
};

export const selfAssesmentReportTypeRoute: Record<string, PathMethodType | null> = {
  [ReportType.CERT]: null,
  [ReportType.JUMP]: null,
  [ReportType.PROP]: null,
  [ReportType.EDUC1]: apprentice_education_report_self_assessment_path,
  [ReportType.EDUC2]: apprentice_education_report_self_assessment_path,
};
